import * as constants from "./../constants";
import { findArrayObject } from '../../utils/utils';
import * as logger from './../../logger';

const defaultState = {
    allTruckCount: 0,
    myTruckCount: 0,
    hiredTruckCount: 0,
    vehiclesMaxPage: null,
    vehicleLedgerData: [],
    vehicleTypes: [],
    createVehicleOpen: false,
    vendors: [],
    createVehicleData: {},
    currentVehicleData: {
        id: null,
        fleetOwnerId: null,
        ownershipType: "",
        vehicleNumber: "",
        vehicleType: "",
        vehicleBodyType: "",
        vendorId: null,
        vendor: { vendorName: "", id: null },
        driver: { name: "", id: null },
        driverName: "",
        driverContactNumber: "",
        vehicleTypeDetails: {},
    },
    singleTruck: {},
    pandl: {},
    expenses: {},
    profitLossMonthly: {},
    profitLossMonthlyPDF: {},
    addExpensePhoto: [],
    vehicleExpenseType: [],
    driverExpenseType: [],
    singleExpenseDetails: [],
    documentConfig: [],
    emiSelectDate: [],
    calenderDates: [],
    truckBooks: {},
    maintenanceUpcoming: [],
    tripPNLMonths: {},
    tripPNLMonthlyPDF: {},
    tripPNLMonths: {},
    tripPNLMonthlyPDF: {},
    documentsBooks: {},
    documentPDF: {},
    singleDriverData: {},
    singleShopData: {},
    driverDeductionTypes: [],
    driverAdditionTypes: [],
    drivers: [],
    singleDriverTransaction: {},
    singleVendorDetails: {},
    defaultDateFilterValue: "",
    defaultTripBookFilterValue: "",
    maintenanceConfig: [],
    simTrackingDetails: {},
    simTrackingLocation: {},
    vehicleMonthlyPnlPdfV2: {},
    vehicleMonthlyPnlPdfLink: {},
    truckIncomeExcel: {},
    singleDriverTransactionOnline: {},
    singleDriverKhataPdf: {},
    dieselCardList: { trucks: [] },
    fuelCardDriverList: [],
    singleDieselCardInfo: { transactionLogs: [] },
    dieselCardTransactionDetails: {},
    dieselCardStepperDetails: {}
};

export default function vehicleReducer(state = defaultState, action) {
    switch (action.type) {
        case constants.GET_VEHICLE_LEDGER_DATA:
            if (action.payload.merge) {
                return {
                    ...state,
                    ...action.payload,
                    vehicleLedgerData: [
                        ...state.vehicleLedgerData,
                        ...action.payload.vehicleLedgerData
                    ]
                };
            } else {
                return { ...state, ...action.payload };
            }
        case constants.UPDATE_CREATE_VEHICLE_OPEN:
            return { ...state, ...{ createVehicleOpen: !state.createVehicleOpen } };
        case constants.ADD_VEHICLE:
            return { ...state, ...{ addedVehicle: action.payload } }
        case constants.UPDATE_VEHICLE:
            return { ...state, ...{ updatedVehicle: action.payload } }
        case constants.UPDATE_CURRENT_VEHICLE_DATA:
            let data = action.payload;
            if (data && data.vehicleBodyTypeKey) {
                let selectedConfigs = findArrayObject('value', data.vehicleBodyTypeKey, state.vehicleTypesConfig);
                selectedConfigs.hide_add_more_details_button = true;
                let modifiedVehicleAttributes = {}
                let havingMoreDetails = false;
                if (data.vehicleAttributes) {
                    data.vehicleAttributes.forEach(attribute => {
                        if (modifiedVehicleAttributes[attribute.field_name]) {
                            modifiedVehicleAttributes[attribute.field_name] = {}
                        }
                        modifiedVehicleAttributes[attribute.field_name] = attribute;
                    });
                    if (selectedConfigs.custom_fields) {
                        selectedConfigs.custom_fields.forEach(configs => {
                            configs.field_value = (modifiedVehicleAttributes[configs.field_name] &&
                                modifiedVehicleAttributes[configs.field_name].field_value) ? modifiedVehicleAttributes[configs.field_name].field_value : '';
                        });
                        havingMoreDetails = selectedConfigs.custom_fields.some(configs => {
                            return (modifiedVehicleAttributes[configs.field_name] &&
                                modifiedVehicleAttributes[configs.field_name].field_value) ? true : false;
                        });
                        selectedConfigs.hide_add_more_details_button = havingMoreDetails;
                    }
                }
                data.vehicleTypeDetails = selectedConfigs ? selectedConfigs : {}
            }
            return { ...state, ...{ currentVehicleData: data } }
        case constants.GET_ALL_VENDOR_DATA:
            return { ...state, ...{ vendors: action.payload } };
        case constants.GET_ALL_DRIVER_DATA:
            return { ...state, ...{ drivers: action.payload } };
        case constants.VEHICLE_TYPES_CONFIG:
            return { ...state, ...{ vehicleTypesConfig: action.payload } };
        case constants.GET_CALENDER_DATES:
            logger.log("VehicleReducer", "Get calender dates", action.payload);
            var dates = { ...state, ...{ calenderDates: action.payload } };
            return { ...state, ...dates };
        case constants.GET_TRUCK_BOOK:
            logger.log("VehicleReducer", "GET TRUCK BOOK", action.payload);
            var book = { ...state, ...{ truckBooks: action.payload }, ...{ defaultExpenseTypeFilterValue: action.payload && action.payload.defaultExpenseTypeFilterValue ? action.payload.defaultExpenseTypeFilterValue : "" } };
            return { ...state, ...book };
        case constants.GET_MAINTENANCE_UPCOMING:
            logger.log("VehicleReducer", "Get maintenance upcoming successfull", action.payload);
            var upcoming = { ...state, ...{ maintenanceUpcoming: action.payload } };
            return { ...state, ...upcoming };
        case constants.GET_EMI_SELECT_DATE:
            logger.log("VehicleReducer", "Emi select date", action.payload);
            var emi = { ...state, ...{ emiSelectDate: action.payload } };
            return { ...state, ...emi };
        case constants.GET_DOCUMENT_CONFIG:
            logger.log("VehicleReducer", "Single Vehicle Document Config Data" + JSON.stringify(action.payload));
            var document = { ...state, ...{ documentConfig: action.payload } }
            return { ...state, ...document };
        case constants.SINGLE_TRUCK_DATA:
            logger.log("VehicleReducer", "Single Truck Data" + JSON.stringify(action.payload));
            let truckdata = action.payload;
            if (truckdata && truckdata.vehicleBodyTypeKey) {
                let selectedConfigs = findArrayObject('value', truckdata.vehicleBodyTypeKey, state.vehicleTypesConfig);
                if (selectedConfigs) {
                    selectedConfigs.hide_add_more_details_button = true;
                }
                let modifiedVehicleAttributes = {}
                let havingMoreDetails = false;
                if (truckdata.vehicleAttributes) {
                    truckdata.vehicleAttributes.forEach(attribute => {
                        if (modifiedVehicleAttributes[attribute.field_name]) {
                            modifiedVehicleAttributes[attribute.field_name] = {}
                        }
                        modifiedVehicleAttributes[attribute.field_name] = attribute;
                    });
                    if (selectedConfigs && selectedConfigs.custom_fields) {
                        selectedConfigs.custom_fields.forEach(configs => {
                            configs.field_value = (modifiedVehicleAttributes[configs.field_name] &&
                                modifiedVehicleAttributes[configs.field_name].field_value) ? modifiedVehicleAttributes[configs.field_name].field_value : '';
                        });
                        havingMoreDetails = selectedConfigs.custom_fields.some(configs => {
                            return (modifiedVehicleAttributes[configs.field_name] &&
                                modifiedVehicleAttributes[configs.field_name].field_value) ? true : false;
                        });
                        selectedConfigs.hide_add_more_details_button = havingMoreDetails;
                    }
                }
                truckdata.vehicleTypeDetails = selectedConfigs ? selectedConfigs : {}
            }
            var singleTruck = { ...state, ...{ singleTruck: truckdata } }
            return { ...state, ...singleTruck };
        case constants.TRIP_EXPENSES:
            logger.log("VehicleReducer", "Single Truck Data" + JSON.stringify(action.payload));
            var Expenses = { ...state, ...{ expenses: action.payload && action.payload.payloadData ? action.payload.payloadData : {} }, ...{ defaultTripBookFilterValue: action.payload && action.payload.defaultTripBookFilter ? action.payload.defaultTripBookFilter : "" } }
            return { ...state, ...Expenses };
        case constants.ADD_EXPENSE_PHOTO_UPLOAD:
            logger.log("VehicleReducer", "Add Expense Photo", action.payload);
            var Photo = { ...state, ...{ addExpensePhoto: action.payload } }
            return { ...state, ...Photo };
        case constants.P_AND_L:
            logger.log("VehicleReducer", "Single Truck Data" + JSON.stringify(action.payload));
            var PandL = { ...state, ...{ pandl: action.payload && action.payload.payloadData ? action.payload.payloadData : {} }, ...{ defaultDateFilterValue: action.payload && action.payload.defaultDateFilter ? action.payload.defaultDateFilter : "" } }
            return { ...state, ...PandL };
        case constants.VEHIClE_PROFIT_AND_LOSS_MONTHLY:
            return { ...state, ...{ profitLossMonthly: action.payload } };
        case constants.VEHIClE_PROFIT_AND_LOSS_MONTHLY_PDF:
            return { ...state, ...{ profitLossMonthlyPDF: action.payload } }
        case constants.GET_TRIP_PNL_MONTHS:
            return { ...state, ...{ tripPNLMonths: action.payload } }
        case constants.GET_TRIP_PNL_MONTHLY_PDF:
            return { ...state, ...{ tripPNLMonthlyPDF: action.payload } }
        case constants.GET_VEHICLE_DOCUMENT_PDF:
            return { ...state, ...{ documentPDF: action.payload } }
        case constants.GET_VEHICLE_DOCUMENTS_BOOK:
            return { ...state, ...{ documentsBooks: action.payload } }
        case constants.VEHICLE_EXPENSE_TYPE:
            logger.log("VehicleReducer", "vehicle expense types", action.payload);
            var expenseType = { ...state, ...{ vehicleExpenseType: action.payload } }
            return { ...state, ...expenseType }
        case constants.DRIVER_EXPENSE_TYPE:
            logger.log("VehicleReducer", "Driver expense type", action.payload);
            var expenseType = { ...state, ...{ driverExpenseType: action.payload } }
            return { ...state, ...expenseType }
        case constants.GET_SINGLE_EXPENSE:
            logger.log("VehicleReducer", "Single expense details", action.payload);
            var expenseDetails = { ...state, ...{ singleExpenseDetails: action.payload } }
            return { ...state, ...expenseDetails }
        case constants.UPDATE_NEW_VENDOR_DATA:
            logger.log("VehicleReducer", "--> UPDATE_NEW_VENDOR_DATA : " + JSON.stringify(action.payload));
            var currentVehicleNewVendor = { ...state.currentVehicleData, ...{ vendor: action.payload } }
            return { ...state, ...currentVehicleNewVendor };
        case constants.UPDATE_NEW_DRIVER_DATA:
            logger.log("VehicleReducer", "--> UPDATE_NEW_DRIVER_DATA : " + JSON.stringify(action.payload));
            var currentVehicleNewDriver = { ...state.currentVehicleData, ...{ vendor: action.payload } }
            return { ...state, ...currentVehicleNewDriver };
        case constants.SINGLE_DRIVER_DETAILS:
            logger.log("Vehicle reducer", action.payload);
            if (action.payload.merge) {
                let singleDriverData = {
                    ...action.payload,
                    transactions: [
                        ...state.singleDriverData.transactions,
                        ...action.payload.transactions
                    ]
                };
                return { ...state, ...{ singleDriverData: singleDriverData } }
            } else {
                return { ...state, ...{ singleDriverData: action.payload } };
            }
        case constants.GET_SINGLE_SHOP_DETAILS:
            logger.log("Vehicle reducer", action.payload);
            if (action.payload.merge) {
                let singleShopData = {
                    ...action.payload,
                    transactions: [
                        ...state.singleShopData.transactions,
                        ...action.payload.transactions
                    ]
                };
                return { ...state, ...{ singleShopData: singleShopData } }
            } else {
                return { ...state, ...{ singleShopData: action.payload } };
            }
        case constants.GET_DRIVER_DEDUCTION_TYPES:
            logger.log("Vehicle Reducer", action.payload);
            var deductionTypes = { ...state, ...{ driverDeductionTypes: action.payload } }
            return { ...state, ...deductionTypes };
        case constants.GET_DRIVER_ADDITION_TYPES:
            logger.log("Vehicle Reducer", action.payload);
            var additionTypes = { ...state, ...{ driverAdditionTypes: action.payload } }
            return { ...state, ...additionTypes };
        case constants.GET_SINGLE_DRIVER_TRANSACTION:
            logger.log("Vehicle Reducer", action.payload);
            var singleTransaction = { ...state, ...{ singleDriverTransaction: action.payload } }
            return { ...state, ...singleTransaction };
        case constants.GET_ONLINE_DRIVER_TRANSACTION:
            var singleDriverTransactionOnline = { ...state, ...{ singleDriverTransactionOnline: action.payload } }
            return { ...state, ...singleDriverTransactionOnline };
        case constants.GET_SINGLE_VENDOR_DETAILS:
            logger.log("Vehicle Reducer", action.payload);
            var singleVendor = { ...state, ...{ singleVendorDetails: action.payload } }
            return { ...state, ...singleVendor };
        case constants.GET_VEHICLE_CONFIG:
            logger.log("Vehicle Reducer", action.payloadData);
            var maintenanceConfig = { ...state, ...{ maintenanceConfig: action.payloadData } }
            return { ...state, ...maintenanceConfig };
        case constants.GET_SIM_TRACKING_DETAILS:
            logger.log("Vehicle Reducer", action.payloadData);
            var simTracking = { ...state, ...{ simTrackingDetails: action.payload } }
            return { ...state, ...simTracking };
        case constants.GET_LOCATIONS_FOR_SIM_TRACKING:
            logger.log("Vehicle Reducer", action.payloadData);
            var simLocations = { ...state, ...{ simTrackingLocation: action.payload } }
            return { ...state, ...simLocations }
        case constants.GET_VEHICLE_MONTHLY_PNL_PDF:
            var vehicleMonthlyPnlPdfV2 = { ...state, ...{ vehicleMonthlyPnlPdfV2: action.payload } }
            return { ...state, ...vehicleMonthlyPnlPdfV2 }
        case constants.GET_VEHICLE_MONTHLY_PNL_PDF_LINK:
            var vehicleMonthlyPnlPdfLink = { ...state, ...{ vehicleMonthlyPnlPdfLink: action.payload } }
            return { ...state, ...vehicleMonthlyPnlPdfLink }
        case constants.GET_TRUCK_INCOME_EXCEL:
            var truckIncomeExcel = { ...state, ...{ truckIncomeExcel: action.payload } }
            return { ...state, ...truckIncomeExcel }
        case constants.GET_SINGLE_DRIVER_KHATA_PDF:
            var singleDriverKhataPdfInfo = { ...state, ...{ singleDriverKhataPdf: action.payload } }
            return { ...state, ...singleDriverKhataPdfInfo }
        case constants.GET_DIESEL_CARD_LIST:
            var dieselCardListResponse = action.payload.dieselCardData;

            if (action.payload.merge) {

                dieselCardListResponse.trucks = [
                    ...state.dieselCardList.trucks,
                    ...action.payload.dieselCardData.trucks
                ]

            }

            return { ...state, ...{ dieselCardList: dieselCardListResponse } }
        case constants.GET_FUEL_CARD_DRIVERS_LIST:
            return { ...state, ...{ fuelCardDriverList: action.payload } }
        case constants.GET_SINGLE_DIESEL_CARD:
            var singleDieselCardResponse = action.payload.responseData

            if (action.payload.merge) {
                singleDieselCardResponse.transactionLogs = [
                    ...state.singleDieselCardInfo.transactionLogs,
                    ...singleDieselCardResponse.transactionLogs
                ]
            }

            return { ...state, ...{ singleDieselCardInfo: singleDieselCardResponse } }
        case constants.GET_DIESEL_CARD_TRANSACTION_DETAILS:
            var dieselCardTransactionInfo = action.payload;

            return { ...state, ...{ dieselCardTransactionDetails: dieselCardTransactionInfo } }
        case constants.GET_CASHBACK_STEPPER:
            var dieselCardStepper = action.payload;

            return { ...state, ...{ dieselCardStepperDetails: dieselCardStepper } }
        default:
            return state
    }
}
